export const DEFAULT_PLACEHOLDER = '--'
